customElements.get("usp-detail-link") || customElements.define("usp-detail-link", class extends HTMLElement {
  constructor() {
    super(), this.desktopMQ = window.matchMedia("(min-width: 1025px)"), this.handleClick = this.handleClick.bind(this), 
    this.updateExpanded = this.updateExpanded.bind(this);
  }
  getItemId() {
    try {
      let t = (this.closest("[data-product]") || this.closest(".shopify-section")).querySelector('form[action*="/cart/add"] [name="id"]');
      if (t) return t.dataset.variantSku || t.value;
      if (t = document.querySelector('form[action*="/cart/add"] [name="id"]'), t) return t.dataset.variantSku || t.value;
      const e = document.querySelector("product-form[data-product-id]");
      return e ? e.getAttribute("data-product-id") : "";
    } catch (t) {
      return "";
    }
  }
  getProductId() {
    try {
      const t = document.querySelector("product-form[data-product-id]");
      return t ? t.getAttribute("data-product-id") : "";
    } catch (t) {
      return "";
    }
  }
  getProductTitle() {
    try {
      const t = document.querySelector("product-form[data-product-title]");
      return t ? t.getAttribute("data-product-title") : "";
    } catch (t) {
      return "";
    }
  }
  handleClick(t) {
    if (!(this.desktopMQ.matches ? this.openDrawer() : this.openAccordion())) {
      const t = this.dataset.fallbackHref;
      t ? window.location.assign(t) : console.warn("usp-detail-link: target not found", this.dataset.detailKey);
    }
    try {
      if ("product" === document.body.getAttribute("data-template")) {
        const t = this.querySelector("button"), e = this.getAttribute("data-heading") || (t ? t.textContent.trim() : null), d = this.getItemId(), a = this.getProductId(), n = this.getProductTitle();
        window.dataLayer = window.dataLayer || [], window.dataLayer.push({
          event: "select_content",
          content_type: "pdp_information",
          item_id: d,
          item_name: n,
          product_id: a,
          faq_question: e,
          page_section: "main-content",
          page_type: "pdp"
        });
      }
    } catch (t) {
      console.warn("GTM Error in usp-detail-link:", t);
    }
  }
  openDrawer() {
    const t = document.getElementById(this.dataset.detailKey), e = document.getElementById(this.dataset.modalTarget);
    return !(!t || !e || (t.click(), e.checked || e.click(), 0));
  }
  openAccordion() {
    const t = document.getElementById(this.dataset.accordionTarget);
    if (!t) return !1;
    t.open = !0;
    const e = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10) || 0, d = t.getBoundingClientRect().top + window.scrollY - e - 8;
    return window.scrollTo({
      top: d,
      behavior: "smooth"
    }), !0;
  }
  updateExpanded() {
    const t = this.desktopMQ.matches ? Boolean(this.modal && this.modal.checked) : Boolean(this.accordion && this.accordion.open);
    this.button?.setAttribute("aria-expanded", t ? "true" : "false");
  }
  connectedCallback() {
    this.button = this.querySelector("button"), this.modal = document.getElementById(this.dataset.modalTarget), 
    this.accordion = document.getElementById(this.dataset.accordionTarget), this.addEventListener("click", this.handleClick), 
    this.desktopMQ.addEventListener("change", this.updateExpanded), this.modal?.addEventListener("change", this.updateExpanded), 
    this.accordion?.addEventListener("toggle", this.updateExpanded), this.updateExpanded();
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick), this.desktopMQ.removeEventListener("change", this.updateExpanded), 
    this.modal?.removeEventListener("change", this.updateExpanded), this.accordion?.removeEventListener("toggle", this.updateExpanded);
  }
});